/* AstaLab 2.0 — /reset-password (obiettivo 3). Raggiunta dal link contenuto
   nell'email di recupero (deploy reale) — nell'Artifact/demo la password si
   aggiorna comunque, solo restando locale a questo browser (vedi notice). */
import { escapeHtml } from "../components/escapeHtml.js";
import { renderNoticeIfAny } from "../components/DemoModeBanner.js";
import { AUTH_PASSWORD_MIN_LENGTH, passwordPolicyHint } from "../../config/authPolicy.js";

export function renderResetPasswordPage(container, ctx){
  container.innerHTML =
    '<div class="auth-card">' +
      '<h1>Imposta una nuova password</h1>' +
      '<form id="resetForm">' +
        '<label class="field">Nuova password (' + passwordPolicyHint() + ')<input type="password" id="resetPassword" required minlength="' + AUTH_PASSWORD_MIN_LENGTH + '" autocomplete="new-password"></label>' +
        '<button type="submit" class="btn primary">Aggiorna password</button>' +
      '</form>' +
      '<div id="resetMsg"></div>' +
    '</div>';

  const form = container.querySelector("#resetForm");
  const msg = container.querySelector("#resetMsg");
  const submitBtn = form.querySelector('button[type="submit"]');
  // Round Beta-P3-2: stessa guardia locale di LoginPage.js — vedi il commento esteso lì.
  let submitting = false;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if(submitting) return;
    submitting = true;
    submitBtn.disabled = true;
    try{
      msg.innerHTML = "";
      const password = container.querySelector("#resetPassword").value;
      const result = await ctx.adapter.updatePassword(password);
      if(!result.ok){
        msg.innerHTML = '<p class="errtext">' + escapeHtml(result.error) + "</p>";
        return;
      }
      msg.innerHTML = renderNoticeIfAny(result) || '<p class="okmsg">Password aggiornata.</p>';
    } finally {
      submitting = false;
      submitBtn.disabled = false;
    }
  });
}
